/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelogitem_Type1Inputs */

const id_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis`)
};

const ms_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis`)
};

const da_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const en_us2_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const es_es2_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const es_mx2_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const fil_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uri`)
};

const fr_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const it_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const hu_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Típus`)
};

const nl_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const no_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const pl_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const pt_br2_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const pt_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const ro_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tip`)
};

const fi_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tyyppi`)
};

const sv_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const vi_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại`)
};

const tr_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tür`)
};

const cs_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const bg_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const ru_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const uk_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const ar_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النوع`)
};

const hi_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकार`)
};

const th_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประเภท`)
};

const ja_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイプ`)
};

const zh_cn2_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const zh_hant1_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const ko_components_changelogitem_type1 = /** @type {(inputs: Components_Changelogitem_Type1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Components_Changelogitem_Type1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelogitem_type1 = /** @type {((inputs?: Components_Changelogitem_Type1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelogitem_Type1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelogitem_type1(inputs)
	if (locale === "ms") return ms_components_changelogitem_type1(inputs)
	if (locale === "da") return da_components_changelogitem_type1(inputs)
	if (locale === "de") return de_components_changelogitem_type1(inputs)
	if (locale === "en-US") return en_us2_components_changelogitem_type1(inputs)
	if (locale === "es-ES") return es_es2_components_changelogitem_type1(inputs)
	if (locale === "es-MX") return es_mx2_components_changelogitem_type1(inputs)
	if (locale === "fil") return fil_components_changelogitem_type1(inputs)
	if (locale === "fr") return fr_components_changelogitem_type1(inputs)
	if (locale === "it") return it_components_changelogitem_type1(inputs)
	if (locale === "hu") return hu_components_changelogitem_type1(inputs)
	if (locale === "nl") return nl_components_changelogitem_type1(inputs)
	if (locale === "no") return no_components_changelogitem_type1(inputs)
	if (locale === "pl") return pl_components_changelogitem_type1(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelogitem_type1(inputs)
	if (locale === "pt") return pt_components_changelogitem_type1(inputs)
	if (locale === "ro") return ro_components_changelogitem_type1(inputs)
	if (locale === "fi") return fi_components_changelogitem_type1(inputs)
	if (locale === "sv") return sv_components_changelogitem_type1(inputs)
	if (locale === "vi") return vi_components_changelogitem_type1(inputs)
	if (locale === "tr") return tr_components_changelogitem_type1(inputs)
	if (locale === "cs") return cs_components_changelogitem_type1(inputs)
	if (locale === "bg") return bg_components_changelogitem_type1(inputs)
	if (locale === "ru") return ru_components_changelogitem_type1(inputs)
	if (locale === "uk") return uk_components_changelogitem_type1(inputs)
	if (locale === "ar") return ar_components_changelogitem_type1(inputs)
	if (locale === "hi") return hi_components_changelogitem_type1(inputs)
	if (locale === "th") return th_components_changelogitem_type1(inputs)
	if (locale === "ja") return ja_components_changelogitem_type1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelogitem_type1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelogitem_type1(inputs)
	return ko_components_changelogitem_type1(inputs)
});
export { components_changelogitem_type1 as "components.changelogItem.type" }